import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SearchSettingsModel, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { BsModalService } from 'ngx-bootstrap';
import { MysqlService } from 'src/app/services/mysql.service';
import { HotToastService } from '@ngneat/hot-toast';


@Component({
  selector: 'app-system-file-manager',
  templateUrl: './system-file-manager.component.html',
  styleUrls: ['./system-file-manager.component.css'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService]
})
export class SystemFileManagerComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;
    public searchOptions: SearchSettingsModel;

    @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();
    @Output('onAdd') onAdd: EventEmitter<any> = new EventEmitter();
    @Input() is_attach_method?;
 
    @Input() attach_file_array_name?: any;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;
  files: any;
  modalRef: any;
  del_files: Object;

  files_data: any;
  agent_array: any;
  show_agents: any;
  created_file: {
    // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    // log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    // created_by: this.gfunc.sessionUserId,
    // created_date: this.gfunc.today,
    // subject_id: this.subject_id,
    // job_id: this.job_id,
    // job_reference_number: this.job_id,
    // file_number: this.file_number,
    // reference_number: this.reference_number,
    // subject_number: this.subject_number,
    // // subject_number: model.file_subject_number,
    // log_type_id: 1, // see datatable system_log_types
    // created_level: this.gfunc.sessionUserLevel,
    // brand_type_id: brand_type_id,
    // subject_com_type_id: null,
    // subject_template_doc_id: null,
    // log_name: log_name + ' - ' + this.created_file_name,
    // file_id: inserted_file_id,
    // last_insert_id: this.returned_created_file_id,
    // file_name: this.created_file_name
    file_name: any; job_file: number; subject_file: number; file_id: any; file_server_location: any; file_ext: any; file_brand_id: any; file_access_level: any; assigned_to_agents: any; brand_type_id: any;
  }[];
  file_data: any[];
  file_password_data: any;
  file_password: any;

  constructor(
    private _demoService: DemoService,
    private route: ActivatedRoute, private router: Router,
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,
    private _mysqlService: MysqlService,
    private toastr: HotToastService,
  ) { 
        // Setup Grid
        this.toolbarOptions = ['ExcelExport', 'Search', {
          text: 'TRY ME!',
          tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
        }
        ];
        // this.toolbar = [
        // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
      //  this.initialPage = { pageSize: 100 };
        this.filterOptions = {
          type: 'Menu'
        };
        this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
        this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
        this.dateFormat = 'dd/MM/yyyy hh:mm a';
        this.filter = { params: { format: this.dateFormat } };
  }

  ngOnInit() {
    this.getFiles();
  }


  private getFiles() {
    this._demoService.fetchSystemFiles().subscribe(
      (res) => (this.files = res),
      (err) => console.error(err.status)
    );
  } /* */

// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.files }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}

// subjectEditLink(subject_id) {
//   this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
// }


// viewSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
// }

// editSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
// }

// editDocFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
// }


// editDocxSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
// }


// viewDocxSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
// }


subjectEditLink(subject_id) { 
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
}


viewSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  this.gfunc.globalViewSystemFile(file_id);
}

editSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
  this.gfunc.globalEditSystemFile(file_id);
}

editDocFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  this.gfunc.globalEditDocFile(file_id);
}


editDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  this.gfunc.globalEditDocxSystemFile(file_id);
}

editDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit-html/' + file_id + '']);
}



viewDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  this.gfunc.globalViewDocxSystemFile(file_id);
}

viewDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view-html/' + file_id + '']);
}



// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.refreshGrid();
  this.modalRef.hide();
 
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list


};



clearSearchGrid() {
  this.grid.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}

searchGridCol(name) {
// const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
// const searchText: string = name;
// this.grid.search(searchText);

// clear first
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { fields: ['file_make'], operator: 'contains', key: name, ignoreCase: true };
// now refresh the grid
this.grid.refresh();
}



// NOT WORKING
searchGridMasters(name) {
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { 
  fields: ['assigned_to_subjects'], operator: 'equal', key: name
 
};
// now refresh the grid
this.grid.refresh();

}





// New delete any job or subject file fuction - Beta Testing
deleteJobFileAny(filename, job_id, file_make, file_server_location) {
  // if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFileAny(filename, job_id, file_make, file_server_location).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
        this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        //  return Observable.throw(error);
       }
    );
// }
}

deleteSystemFileAssigned(model){
  this._demoService.deleteSystemFileAssigned(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('Assigned Files deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Records Removed")
      ),
    (err) => console.error(err.status)
  );
}




deleteSystemFile(model){
  // if (confirm('Are you sure you want to delete this file assign/share record, master file will remain? ')) {
  this._demoService.deleteSystemFile(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('File deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Record Removed"),
      // this.grid.refresh() 
      this.refreshGrid()
      ),
    (err) => console.error(err.status)
  );
    // }
}



// this deletes the lot!
deleteSystemJobFile(model) {
  console.log('FileID: ', model.file_id);
  if (confirm('Are you sure you want to delete this file, data and associations from the system? ')) {
  // change into a subscruption and delete the file action.
// 1: delete from database + Log action
this.deleteSystemFileAssigned(model);
// 2: Delete file from server
this.deleteSystemFile(model);
// logg the process
this.gfunc.insertLog_DeleteSystemFile(model);
// 3: Delete the pysical file from the server file
if (model.file_server_location !== '') {
this.deleteJobFileAny(model.full_file_name, model.file_job_id, model.file_make, model.file_server_location);
console.log('physicalFILEdelete active: ');
// find out what type of tile it is and then detete the file.
}
console.log('Success: Data + File deleted', model.file_id + ' ' + model.full_file_name);
this.refreshGrid();
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
 // this.gfunc.globalViewSystemFile(file_id);

 // REfreshes page to try fixc upload error after deleting a file.
 if (this.gfunc.current_base_route == '/client/jobs/create-job-wizard-step-3/'){
  // this.gfunc.globalJobEditStep3SkipRoute(this.job_id);
 }

  } // end confirm
}

refreshGrid(){ // refresh the databutton
  this.getFiles();
  this.grid.refresh();
};



 // Function setup to lookup file details and add to arrays of the attempt page automatically.
 onAttachttemptFile(data, attach_file_array_name){
  // need to lookup the file
  // htne fill the sysetm 
// this.toastr.info('attempting to auto attach to attempt report for you ...');

  // set the variable and addd to the model to auto add the attmpt files to the correct array
  ///this.file_data[0].attach_file_array_name = this.attach_file_array_name;
  ///// re model quicky to add the record of the array name to the data model
  this.file_data = [{
  ...data,
  attach_file_array_name: attach_file_array_name
  }]

  console.log('Created File: ', JSON.stringify(this.file_data) );


  // this.file_data = DataUtil.parse.parseJson(this.file_data); // needs to be in grid format for orginal add onAdd Grid Button.
  this.onAdd.emit(this.file_data);

}




getFilePasswordKeyHash(model) {
this.file_password = ''; // reset them all so just show current.
this._demoService.getFilePasswordKeyHash(model).subscribe(
data => { 
this.file_password_data = data;
this.file_password = this.file_password_data.file_password

},
err => console.error(err),
() => console.log('done loading company')
);
}



encryptSystemFile(model) {
// generate more data first
if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {

    // 
    // need to create a pre_backup of file UUFID_bkp.pdf // if require the original file.
    // Do this at the FTP/PHP Level and create a button to access (Original)

this._mysqlService.encryptSystemFile(model).subscribe(
(data) => {
// this.trace_candidate_update = data;
this.toastr.success('Document Encryption Success.');

this.gfunc.insertLog_EncryptPDFFile(model); // new encrypt file log and action.

const res = data;
this.refreshGrid();
},
(error) => {
  this.toastr.error(error.error)
  this.gfunc.insertLog_EncryptPDFFileERROR(model); // new encrypt file log and action.
// return error.error;
},
//  () => console.log('')
);
}
}



}
